export const cssColors = {
  colorGrey4: "#656568",
  colorGrey4Active: "#535358",
  colorGrey3: "#C4C4CA",
  colorGrey3Active: "#ADADB3",
  colorGrey2: "#E8E8EB",
  colorGrey2Active: "#D9D9DE",
  colorGrey1: "#F3F3F5",
  colorWhite: "#FFFFFF",
  colorUiGood: "#39C379",
  colorUiBad: "#E81641",
  colorUiPrimary: "#0975EF",
  colorUiPrimaryActive: "#005DC7",
  colorUiPrimary100: "#EBF3FE",
  colorUiPrimary150: "#D4E6FC",
  colorUiPrimary200: "#BEDAFB",
  colorBlack: "#101820",
  colorGrey5: "#EFEFF1",
  colorAnalyticsPrimary: "#0050C7",
  adaColor: "#3A8AFA",
  colorGreyBg: "#F9F9F9"
};

export const cssVariables = {
  gUnitDouble: "16px",
  gUnit: "8px",
  gUnitHalf: "4px",

  xSmallFontSize: "12px",
  smallFontSize: "14px",
  smallFontSizeAlt: "13px",
  mainFontSize: "16px",
  largeFontSize: "18px",
  bigFontSize: "24px",

  smallLineHeight: "16px",
  mediumLineHeight: "20px",

  xHeavyFontWeight: 700,
  heavyFontWeight: 600,
  mediumFontWeight: 500,

  midContainerWidth: "590px",
  largeContainerWidth: "790px",
  windowBreakpoint: "1200px",

  smallerBorderRadius: "4px",
  smallBorderRadius: "6px",
  mainBorderRadius: "8px",
  bigBorderRadius: "12px",

  smallIconWidth: "24px",
  smallIconHeight: "24px",
  mediumIconWidth: "32px",
  mediumIconHeight: "32px",

  transitionTime: "180ms"
};
